const DepartList: LoginWay[] = [
	{ id: "0", name: "管理部门" },
	{ id: "1", name: "销售部门" },
	{ id: "2", name: "研发部门" },
	{ id: "3", name: "其他部门" }
];

export const DepartArray: string[] = ["管理部门", "销售部门", "研发部门", "其他部门"];

export default DepartList;